import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guide",
  "use": "icon-guide-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-guide\"><path d=\"M404.96 137.6V81.44h106.08V137.6h53.28V32H351.68v105.6zM511.04 512v431.04H404.96V512H351.68v480h212.64V512z\" p-id=\"1032\" /><path d=\"M834.08 134.24H33.44v379.2h801.12l158.88-187.2-159.36-192z m-43.2 324.96H92.96V192.8h697.92l118.56 132.48L790.88 459.2z\" p-id=\"1033\" /><path d=\"M193.28 298.4h532.8v53.28h-532.8z\" p-id=\"1034\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol